import { useState } from 'react';
import {
  Button, TextField, Grid2 as Grid, Typography, IconButton
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

import { changePassForgot } from '../../actions/users';

import { isEmpty } from '../common/helpers';

const CrearPass = ({
  navigate, setPasos, setExito, dataParent
}) => {
  const [data, setData] = useState({
    password: '',
    password2: ''
  });
  const [error, setError] = useState({
    password: '',
    password2: ''
  });
  const [id, setId] = useState(dataParent.userId);

  /* Elimino useEffect de user y useSelector */

  const changePass = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  }

  const guardar = async e => {
    e.preventDefault();
    if (isEmpty(data.password)) {
      return setError({
        password: 'Un campo esta vacio',
        password2: 'Un campo esta vacio'
      })
    }
    if (data.password !== data.password2) {
      return setError({
        password: 'No coinciden',
        password2: 'No coinciden'
      });
    }
    const info = {
      password: data.password
    }
    const resChange = await changePassForgot(info, id);
    console.log(resChange);
    if (resChange) {
      setExito(true);
      setPasos(5);
    }
  }

  return (
    <form noValidate onSubmit={guardar}>
      <Grid container sx={{ my: 2 }} spacing={{ sx: 1 }}>
        <Grid item xs={12}>
          <IconButton
            className="btn-icon"
            aria-label="back"
            onClick={() => navigate(-1)}
          >
            <ChevronLeftIcon />
          </IconButton>
        </Grid>
        <Grid className="step-pass" item container direction="column">
          <Typography variant="h3" component="h3">Crear nueva contraseña</Typography>
          <Typography component="p">
            Su nueva contraseña debe ser única con respecto a las utilizadas anteriormente.
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextField
            error={isEmpty(error.password) ? false : true}
            type="password"
            variant="outlined"
            fullWidth
            id="password"
            label="Contraseña"
            name="password"
            value={data.password}
            onChange={changePass}
            helperText={!isEmpty(error.password) && error.password}
          />
        </Grid>
        <Grid className="content-description" item xs={12} md={6}>
          <h5>Tu contraseña debe:</h5>
          <ul className="list">
            <li>Mínimo 8 caracteres.</li>
            <li>Mínimo 2 números.</li>
            <li>Mínimo 1 carácter especial.</li>
            <li>Mínimo 1 letra mayúscula.</li>
            <li>Mínimo 1 letra minúscula.</li>
          </ul>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextField
            error={isEmpty(error.password2) ? false : true}
            type="password"
            variant="outlined"
            fullWidth
            id="password2"
            label="Confirmar password"
            name="password2"
            value={data.password2}
            onChange={changePass}
            helperText={!isEmpty(error.password2) && error.password2}
          />
        </Grid>
      </Grid>
      <Grid item xs={6} sx={{ mt: 3 }}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
        >
          Guardar
        </Button>
      </Grid>
    </form>
  );
}

CrearPass.propTypes = {
  setPasos: PropTypes.func.isRequired,
  setExito: PropTypes.func.isRequired,
  dataParent: PropTypes.object.isRequired
}

export default CrearPass;
